import { useEffect, useState } from "react";
import api from "@/lib/api";

// Single source of truth for the current user's module permissions (OWNER = all).
// Cached at module scope so page guards + topbar don't refetch on every navigation.
let _cache = null;
let _promise = null;

export function primeModules() {
  if (!_promise) {
    _promise = api.get("/users/me/modules").then((r) => { _cache = r.data; return r.data; });
  }
  return _promise;
}

export function useModules() {
  const [mods, setMods] = useState(_cache);
  useEffect(() => {
    let alive = true;
    if (_cache) { setMods(_cache); return; }
    primeModules().then((d) => { if (alive) setMods(d); }).catch(() => { if (alive) setMods({ role: null, modules: [] }); });
    return () => { alive = false; };
  }, []);
  const can = (m) => !!mods && (mods.role === "OWNER" || (mods.modules || []).includes(m));
  return { mods, can, ready: !!mods };
}
